module.exports = __webpack_public_path__ + "static/media/videoHome.86de9c7c.mp4";